/*
 * This file is part of the Det Norske Teatret application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React, { type ComponentProps } from 'react';
import DoubleTitle from './DoubleTitle/DoubleTitle';
import LargeImage from './LargeImage/LargeImage';
import LargeIntro from './LargeIntro/LargeIntro';
import Video from './Video/Video';
import SideImage from './SideImage/SideImage';
import BottomImage from './BottomImage/BottomImage';
import FullHeightHalfImage from './FullHeightHalfImage/FullHeightHalfImage';
import './Header.scss';

type HeaderType =
  | 'doubleTitle'
  | 'largeImage'
  | 'largeIntro'
  | 'videoEntry'
  | 'sideImage'
  | 'bottomImage'
  | 'fullHeightHalfImage';

interface HeaderProps {
  type?: HeaderType;
  // The rest goes to the header the type picks, and comes from the API.
  [prop: string]: unknown;
}

/**
 * This is the Header component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 */
function Header({ type = 'doubleTitle', ...props }: HeaderProps) {
  if (type === 'videoEntry') {
    return <Video {...(props as unknown as ComponentProps<typeof Video>)} />;
  }

  if (type === 'largeImage') {
    return (
      <LargeImage
        {...(props as unknown as ComponentProps<typeof LargeImage>)}
      />
    );
  }

  if (type === 'largeIntro') {
    return (
      <LargeIntro
        {...(props as unknown as ComponentProps<typeof LargeIntro>)}
      />
    );
  }

  if (type === 'sideImage') {
    return (
      <SideImage {...(props as unknown as ComponentProps<typeof SideImage>)} />
    );
  }

  if (type === 'bottomImage') {
    return (
      <BottomImage
        {...(props as unknown as ComponentProps<typeof BottomImage>)}
      />
    );
  }

  if (type === 'fullHeightHalfImage') {
    return (
      <FullHeightHalfImage
        {...(props as unknown as ComponentProps<typeof FullHeightHalfImage>)}
      />
    );
  }

  return (
    <DoubleTitle
      {...(props as unknown as ComponentProps<typeof DoubleTitle>)}
    />
  );
}

export default Header;
